export default __webpack_public_path__ + "static/media/no-image.ebbc7b17.png";